import React from 'react'
import { useRoute } from 'react-router5'
import { Chip, useMediaQuery } from '@mui/material'
import { connect } from "react-redux"
import { httpClient } from 'funcs'

import StoreProps from 'utils/types/storeProps'
import {mobileMaxWidthMediaQuery} from "../../../methods/utils";
import { loadSelf } from '../../../methods/loadSelf'
import SubscribeChannelPopup from '../../../components/SubscribeChannelPopup'

let BalanceHolder: any = function (props: StoreProps) {
  
  const [balance, setBalance] = React.useState<any>()
  const [showGetTestBalance, setShowGetTestBalance] = React.useState(false)
  const mobile = useMediaQuery(mobileMaxWidthMediaQuery)
  
  React.useEffect(() => {
    if (typeof props.$store.balance == 'number') {
      setBalance(props.$store.balance)
    }
  }, [props.$store.balance])

  const handleSuccess = async () => {
    // Обновляем баланс локально без перезагрузки данных пользователя
    // Баланс будет обновлен из ответа API в SubscribeChannelPopup
  }

  const shouldShowGetBalanceButton = () => {
    return props.$store.userSession?.received_test_balance === false
  }

  const GetBalanceButton = () => (
    <button
      className="new withTitle small"
      onClick={(e) => {
        e.stopPropagation()
        setShowGetTestBalance(true)
      }}
      style={{
        background: 'transparent',
        border: '1px solid #FCFCFF',
        color: '#FCFCFF',
        fontSize: '11px',
        padding: '2px 6px',
        borderRadius: '10px',
        fontWeight: '500',
        lineHeight: '1.2',
        minHeight: 'auto'
      }}
    >
      получить +5 документов
    </button>
  )

  const getChipLabel = () => {
    if (shouldShowGetBalanceButton()) {
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span>Баланс: {balance}</span>
          <GetBalanceButton />
        </div>
      )
    }
    return `Баланс: ${balance}`
  }

  if (balance < 0) return null

  if (showGetTestBalance) {
    return <SubscribeChannelPopup 
      onClose={() => setShowGetTestBalance(false)}
      onSuccess={handleSuccess}
      $store={props.$store}
      $commitToStore={props.$commitToStore}
    />
  }

  return <Chip
        sx={{
          background: '#1FA3EE',
          color: "#FCFCFF",
          fontWeight: 400,
          fontSize: "14px",
          lineHeight: "30px",
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '0px',
          position: 'fixed' as const,
          bottom: '0',
          left: '50%',
          transform: 'translate(-50%, 0)',
          marginBottom: '90px',
          width: "auto",
          zIndex: 100,
          opacity: '100 ',
          boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px'
        }}
        label={getChipLabel()}
      />
}

BalanceHolder = connect((store) => ({ $store: store }), (dispatch) => ({ $commitToStore: (data: any) => dispatch({ ...data, type: 'S' }) }))(BalanceHolder)


export default BalanceHolder